/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useCallback, useEffect } from "react";
import { apiClient } from "../../apiCall";
import { useStore } from "../../../store/useStore";
import { Link } from "react-router-dom";
import Loader from "../common/Loader";
import Papa from "papaparse";

export default function ImportDestinations(props) {
	const { state, dispatch } = useStore();
	const apiCall = apiClient(state, dispatch);
	const [file, setFile] = useState(null);
	const [parsedData, setParsedData] = useState([]);
	const [importing, setImporting] = useState(false);
	const [importStatus, setImportStatus] = useState({
		total: 0,
		processed: 0,
		success: 0,
		updated: 0,
		failed: [],
		skipped: [],
		inProgress: false,
	});
	const [error, setError] = useState("");
	const [previewData, setPreviewData] = useState(null);
	const [rawCsvData, setRawCsvData] = useState(null);
	const [clientpackages, setClientpackages] = useState([]);
	const [existingDestinations, setExistingDestinations] = useState([]);
	const [createdClientpackages, setCreatedClientpackages] = useState({});
	const fileInputRef = useRef(null);
	const isMounted = useRef(true);

	// Field mapping from CSV columns to destination fields
	const fieldMapping = {
		Kohde: "name",
		// "Valmis livetettäväksi": "is_published",
		"Otsikko saitille": "alt_title",
		"Teksti saitille": "description",
		"Ohjaava URL": "www",
		Osoite: "address",
		Kaupunki: "city",
		Sometilit: "ig_account",
		Hashtagit: "hashtags",
		Nro: "kohde_numero",
		"Organisaatio ja kohteiden määrä": "organization",
	};

	// Load clientpackages and existing destinations when component mounts
	useEffect(() => {
		loadClientpackages();
		loadExistingDestinations();

		return () => {
			isMounted.current = false;
		};
	}, []);

	const loadClientpackages = async () => {
		try {
			const response = await apiCall.GET("clientpackages");
			if (response?.status === 200 && isMounted.current) {
				setClientpackages(response.data.data || []);
			}
		} catch (err) {
			console.error("Error loading clientpackages:", err);
		}
	};

	const loadExistingDestinations = async () => {
		try {
			const response = await apiCall.GET("destinations", { per_page: 9999 });
			if (response?.status === 200 && isMounted.current) {
				setExistingDestinations(response.data.data || []);
			}
		} catch (err) {
			console.error("Error loading destinations:", err);
		}
	};


	const createClientpackage = async (name) => {
		try {
			const alt_title = (name.split(",")[0] ?? "").trim();

			const clientpackageData = {
				name,
				alt_title: alt_title,
				status: 1, // Set default status
			};

			const response = await apiCall.ADD("clientpackages", clientpackageData);

			if (response?.status === 200) {
				console.log("Created new clientpackage:", response.data.data);
				return response.data.data;
			}
			return null;
		} catch (err) {
			console.error("Failed to create clientpackage:", err);
			return null;
		}
	};

	const isDestinationDuplicate = (kohdeNumero) => {
		return !!getDuplicateDestination(kohdeNumero);
	};
	const getDuplicateDestination = (kohdeNumero) => {
		if (!kohdeNumero) return null;
		let dupe = existingDestinations.find(
			dest => dest.kohde_numero == kohdeNumero
		);

		return dupe
	};

	const handleFileChange = (e) => {
		const selectedFile = e.target.files[0];
		if (selectedFile) {
			setFile(selectedFile);
			parseCSV(selectedFile);
		}
	};

	const parseCSV = (file) => {
		setError("");
		setParsedData([]);
		setPreviewData(null);
		setRawCsvData(null);

		const reader = new FileReader();
		reader.onload = function (e) {
			try {
				const fileContent = e.target.result;
				const rows = fileContent.split(/\r\n|\n/);

				if (rows.length < 3) {
					setError("CSV file doesn't have enough rows");
					return;
				}

				const headerRow = rows[2];
				const dataRows = rows.slice(3).join("\n");
				const csvContent = headerRow + "\n" + dataRows;

				Papa.parse(csvContent, {
					header: true,
					skipEmptyLines: true,
					complete: function (results) {
						if (!isMounted.current) return;

						if (
							results.data &&
							results.data.length > 0 &&
							results.meta &&
							results.meta.fields
						) {
							setParsedData(results.data);

							if (results.data.length > 0) {
								setRawCsvData(results.data[0]);
								const mappedEntry = mapCSVToDestination(results.data[0]);
								setPreviewData(mappedEntry);
							}
						} else {
							setError("CSV format is not valid or file is empty");
						}
					},
					error: function (error) {
						if (isMounted.current) {
							setError(`Error parsing CSV: ${error}`);
						}
					},
				});
			} catch (e) {
				if (isMounted.current) {
					setError(`Error processing CSV file: ${e.message}`);
				}
			}
		};

		reader.onerror = function () {
			if (isMounted.current) {
				setError("Error reading the file");
			}
		};

		reader.readAsText(file);
	};

	const mapCSVToDestination = (csvRow) => {
		if (!csvRow) {
			return null;
		}

		const destination = {
			status: 0,
			location_type: 1,
			is_published: 0,
		};

		Object.keys(fieldMapping).forEach((csvField) => {
			if (
				csvRow.hasOwnProperty(csvField) &&
				csvRow[csvField] &&
				csvRow[csvField].trim() !== ""
			) {
				const destField = fieldMapping[csvField];

				if (destField === "description") {
					destination[destField] = `${csvRow[csvField]}`;
				} else if (destField !== "organization") {
					destination[destField] = csvRow[csvField];
				}
			}
		});

		if (csvRow["Valmis livetettäväksi"] && csvRow["Valmis livetettäväksi"].toLowerCase() === "kyllä") {
			destination.is_published = 1;
		} else {
			console.log(csvRow["Valmis livetettäväksi"], csvRow["Valmis livetettäväksi"].toLowerCase() === "kyllä");
		}

		if (destination.name) {
			// destination.slug = generateSlug(destination.name);
		}

		if (csvRow["Teemakategoria"]) {
			let catsFromCsv = csvRow["Teemakategoria"].split(",").map((cat) => cat.trim()).filter((cat) => cat !== "");
			if (catsFromCsv.length > 0) {
				const destinationCats = catsFromCsv.map((cat) => {
					const existingCat = state.categories.items.find((c) => c.name === cat);
					return existingCat ? existingCat.id : null;
				}).filter((catId) => catId !== null);

				destination.category = destinationCats;
			}
		}

		if (csvRow["Osoite"]) {
			const locationItem = {};

			const addressParts = csvRow["Osoite"].split(",");
			if (addressParts.length > 0) {
				locationItem.address = addressParts[0].trim();

				if (addressParts.length > 1) {
					const postalCodeMatch = addressParts[1].trim().match(/\d+/);
					if (postalCodeMatch) {
						locationItem.postal_code = postalCodeMatch[0];
					}
				}
				if (addressParts.length > 2) {
					locationItem.city = addressParts[2].trim();
				}
			}

			destination.location = [locationItem];
		}

		return destination;
	};

	const startImport = useCallback(async () => {
		if (parsedData.length === 0) {
			setError("No data to import");
			return;
		}

		setImporting(true);
		setImportStatus({
			total: parsedData.length,
			processed: 0,
			success: 0,
			updated: 0,
			failed: [],
			skipped: [],
			inProgress: true,
		 });

		// Just use a local variable for tracking created packages during import
		// No need for React state during the processing loop
		const importSessionPackages = {};

		// for (let i = 0; i < 3; i++) {
		for (let i = 0; i < parsedData.length; i++) {
			if (!isMounted.current) return;

			const csvRow = parsedData[i];

			if (!csvRow["Kohde"] || csvRow["Kohde"].trim() === "") {
				if (isMounted.current) {
					setImportStatus((prev) => ({
						...prev,
						processed: prev.processed + 1,
						skipped: [...prev.skipped, csvRow],
					}));
				}
				continue;
			}

			try {
				const destinationData = mapCSVToDestination(csvRow);

				// Handle clientpackage with local variable
				if (csvRow["Organisaatio ja kohteiden määrä"]) {
					const orgName = csvRow["Organisaatio ja kohteiden määrä"].trim().toLowerCase();
					
					let clientpackageId = null;
					
					// Check our local import session cache first
					if (importSessionPackages[orgName]) {
						clientpackageId = importSessionPackages[orgName].id;
					} else {
						// Then check existing packages
						const clientpackage = clientpackages.find(
							(cp) =>
								cp.name &&
								(cp.name.toLowerCase() === orgName || 
								 cp.name.toLowerCase().includes(orgName))
						);

						if (clientpackage) {
							clientpackageId = clientpackage.id;
						} else {
							// Create new clientpackage if it doesn't exist
							const newClientpackage = await createClientpackage(csvRow["Organisaatio ja kohteiden määrä"]);
							
							if (newClientpackage) {
								// Store in our import session cache
								importSessionPackages[orgName] = newClientpackage;
								clientpackageId = newClientpackage.id;
								
								// Also update the React state for clientpackages
								setClientpackages(prevPackages => [...prevPackages, newClientpackage]);
							}
						}
					}
					
					if (clientpackageId) {
						destinationData.clientpackage_id = clientpackageId;
					}
				}


				let duplicateId = null;
				if (
					destinationData.kohde_numero &&
					isDestinationDuplicate(destinationData.kohde_numero)
				) {
					if (isMounted.current) {
						const existingDestination = getDuplicateDestination(
							destinationData.kohde_numero
						);

						console.log("Duplicate found for", destinationData.kohde_numero, existingDestination);

						if (existingDestination) {
							console.log(
								"Duplicate found for",
								destinationData.kohde_numero,
								existingDestination
							);

							duplicateId = existingDestination.id;
							console.log("Updating existing destination", existingDestination.id);

							// setImportStatus((prev) => ({
							// 	...prev,
							// 	updated: prev.updated + 1,
							// }));
						 }
					}
				}

				const response = duplicateId
					? await apiCall.EDIT("destinations", duplicateId, destinationData, null, true)
					: await apiCall.ADD("destinations", destinationData);

				if (isMounted.current) {
					if (response?.status === 200) {
						setImportStatus((prev) => ({
							...prev,
							processed: prev.processed + 1,
							updated: duplicateId ? prev.updated + 1 : prev.updated,
							success: prev.success + 1,
						}));

						setExistingDestinations((prev) => [...prev, response.data.data]);
					} else {
						setImportStatus((prev) => ({
							...prev,
							processed: prev.processed + 1,
							failed: [
								...prev.failed,
								{ ...csvRow, error: response.data.message },
							],
						}));
					}
				}
			} catch (err) {
				if (isMounted.current) {
					setImportStatus((prev) => ({
						...prev,
						processed: prev.processed + 1,
						failed: [
							...prev.failed,
							{ ...csvRow, error: err.message || "Unknown error" },
						],
					}));
				}
			}
		}

		 // Now that import is done, update the state once for UI purposes
		setCreatedClientpackages(importSessionPackages);

		if (isMounted.current) {
			setImportStatus((prev) => ({
				...prev,
				inProgress: false,
			}));
			setImporting(false);

			apiCall.GET("destinations");
			apiCall.GET("clientpackages");
		}
	}, [parsedData, apiCall, clientpackages]);

	const resetImport = () => {
		setFile(null);
		setParsedData([]);
		setPreviewData(null);
		setRawCsvData(null);
		setImportStatus({
			total: 0,
			processed: 0,
			success: 0,
			failed: 0,
			skipped: 0,
			inProgress: false,
		});
		setError("");
		setCreatedClientpackages({});

		if (fileInputRef.current) {
			fileInputRef.current.value = "";
		}
	};

	return (
		<div className="addnew">
			<section key="search" className="addnewplace search right-padding">
				<h1>Tuo kohteita</h1>
				<div className="wrapper box">

					<div>
						Kategorioita:

						{state.categories.items.map((cat) => (
							<span key={cat.id} className="category-label">
								{cat.name}
							</span>
						))}

					</div>
					<label className="label label-line">
						Ladattava CSV-tiedosto
						<input
							type="file"
							accept=".csv"
							ref={fileInputRef}
							onChange={handleFileChange}
							disabled={importStatus.inProgress}
						/>
					</label>

					{error && (
						<div
							className="error-message"
							style={{ color: "red", margin: "10px 0" }}
						>
							{error}
						</div>
					)}

					{state.clientpackages.loading && (
						<div
							style={{
								margin: "10px 0",
								padding: "10px",
								background: "#fff3cd",
								color: "#856404",
							}}
						>
							Ladataan asiakas-paketteja... Jos listan lataus ei onnistu, CSV:n
							tuominen ei voi jatkua.
						</div>
					)}

					{previewData &&
						!importStatus.inProgress &&
						!(importStatus.processed > 0) && (
							<div className="preview-container">
								<h3>Esikatselu ensimmäisestä kohteesta</h3>
								<div className="preview-data">
									<p>
										<strong>Nimi:</strong> {previewData.name || "Ei nimeä"}
									</p>
									<p>
										<strong>Otsikko:</strong>{" "}
										{previewData.alt_title || "Ei otsikkoa"}
									</p>
									{previewData.description && (
										<p>
											<strong>Kuvaus:</strong>{" "}
											<span
												dangerouslySetInnerHTML={{
													__html: previewData.description,
												}}
											/>
										</p>
									)}
									<p>
										<strong>Verkkosivu:</strong>{" "}
										{previewData.www || "Ei verkkosivua"}
									</p>
									{previewData.location && previewData.location[0] && (
										<p>
											<strong>Osoite:</strong>{" "}
											{previewData.location[0].address || "Ei osoitetta"}
											{previewData.location[0].postal_code
												? `, ${previewData.location[0].postal_code}`
												: ""}
											{previewData.location[0].city
												? `, ${previewData.location[0].city}`
												: ""}
										</p>
									)}
									<p>
										<strong>Some-tilit:</strong>{" "}
										{previewData.ig_account || "Ei some-tilejä"}
									</p>
									<p>
										<strong>Hashtags:</strong>{" "}
										{previewData.hashtags || "Ei hashtageja"}
									</p>
									{previewData.clientpackage_id && (
										<p>
											<strong>Asiakaspaketti:</strong>{" "}
											{clientpackages.find(
												(cp) => cp.id === previewData.clientpackage_id
											)?.name || `ID: ${previewData.clientpackage_id}`}
										</p>
									)}
									<pre
										style={{
											whiteSpace: "pre-wrap",
											maxHeight: "200px",
											overflow: "auto",
											fontSize: "10px",
											backgroundColor: "#f4f4f4",
											padding: "10px",
										}}
									>
										{JSON.stringify(previewData, null, 2)}
									</pre>
								</div>
								<p className="preview-count">
									Tiedostossa on yhteensä {parsedData.length} kohdetta.
								</p>

								<div className="action-buttons">
									<button
										className="button "
										onClick={startImport}
										disabled={
											importStatus.inProgress ||
											parsedData.length === 0 ||
											state.clientpackages.loading
										}
									>
										Aloita tuonti
									</button>
									<button
										className="button secondary"
										onClick={resetImport}
										disabled={importStatus.inProgress}
									>
										Tyhjennä
									</button>
								</div>
							</div>
						)}

					{importStatus.inProgress && (
						<div className="import-progress">
							<Loader className={"dark"} />
							<p>
								Tuodaan kohteita... ({importStatus.processed}/
								{importStatus.total})
							</p>
						</div>
					)}

					{!importStatus.inProgress && importStatus.processed > 0 && (
						<div className="import-results">
							<h3>Tuonti valmis!</h3>
							<p>
								Käsitelty: {importStatus.processed}/{importStatus.total}
							</p>
							<p>Onnistuneet: {importStatus.success}</p>
							<p>Päivitetyt: {importStatus.updated}</p>
							<p>Ohitetut: {importStatus.skipped.length}</p>
							<div className="skipped-list">
								{importStatus.skipped.length > 0 && (
									<>
										<h4>Ohitetut kohteet:</h4>
										<ul>
											{importStatus.skipped.map((item, index) => (
												<li key={index}>
													{item.Nro} - {item.Kohde} -	{item["Organisaatio ja kohteiden määrä"]}
												</li>
											))}
										</ul>
									</>
								)}
							</div>

							<p>Epäonnistuneet: {importStatus.failed.length}</p>
							<div className="error-list">
								{importStatus.failed.length > 0 && (
									<>
										<h4>Epäonnistuneet kohteet:</h4>
										<ul>
											{importStatus.failed.map((item, index) => (
												<li key={index}>
													{item.name} - {item.error}
												</li>
											))}
										</ul>
									</>
								)}
							</div>

							<div className="action-buttons">
								<button className="button " onClick={resetImport}>
									Tuo lisää kohteita
								</button>
								<Link to="/admin/destinations" className="button secondary">
									Siirry kohdelistaan
								</Link>
							</div>
						</div>
					)}
				</div>
			</section>
		</div>
	);
}
